import { isThemeColor, themeColors } from "../utility/themeColors";

export const setStyles = (themeColor: string) => {
  const root = document.documentElement;

  if (themeColor && isThemeColor(themeColor)) {
    const colors = themeColors[themeColor];
    root.style.setProperty("--text", colors.text);
    root.style.setProperty("--accent", colors.accent);
    root.style.setProperty("--hoveredText", colors.hoveredText);
  }
};
